import React from 'react';
import { Origin, EditorType } from '../manage-installed-apps-page';
import { TextButton, EmptyState } from '@wix/design-system';
import { manageAppsAddApp } from '@wix/bi-logger-market/v2';
import { useBiLogger } from '../../hooks/use-bi-logger';
import { useTranslation } from '../../hooks/use-translation';

export function AddAppBox({
  goToHomePage,
  origin,
  msid,
  editorType,
  isEditorless,
}: {
  origin: Origin;
  msid: string;
  goToHomePage(): void;
  editorType: string;
  isEditorless?: boolean;
}) {
  const t = useTranslation();
  const biLogger = useBiLogger();
  const buttonText =
    origin === Origin.DAYFUL
      ? isEditorless
        ? 'manage-apps.empty-state.go-to-editorless-market'
        : 'manage-apps.empty-state.go-to-dayful-market'
      : 'manage-apps.empty-state.go-to-app-market';
  return (
    <EmptyState
      theme="page"
      title={t(
        isEditorless
          ? 'manage-apps.empty-state-editorless.title'
          : 'manage-apps.empty-state.title',
      )}
      subtitle={t(
        isEditorless
          ? 'manage-apps.empty-state-editorless.subtitle'
          : 'manage-apps.empty-state.subtitle',
      )}
    >
      <TextButton
        dataHook="go-to-app-market-button"
        onClick={() => {
          biLogger
            .report(
              manageAppsAddApp({
                market:
                  origin === Origin.BIZMGR
                    ? editorType === EditorType.ADI
                      ? 'adi_dashboard'
                      : 'dashboard'
                    : origin,
                msid,
                referral_info: 'manage_apps',
              }),
            )
            .catch((e) => console.log(e));
          goToHomePage();
        }}
      >
        {t(buttonText)}
      </TextButton>
    </EmptyState>
  );
}
